import axios from 'axios';
import i18n from 'Config/i18n';
import { getDeliveryCountry } from 'Utils/deliveryCountry';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Build an absolute URL for static assets (e.g. watch images) served by the
// backend. Image src attributes can't go through the apiClient interceptors,
// so we prefix the same configured base URL here for consistent behaviour
// across preview/production environments.
export const assetUrl = (path?: string | null): string => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  return `${apiClient.defaults.baseURL || ''}${path}`;
};

// Always tell the backend which language the storefront is currently showing,
// so translated product texts (model/description) are returned for that language,
// and which delivery country is selected, so gross prices are recalculated.
apiClient.interceptors.request.use((config) => {
  const lng = (i18n.language || 'de').slice(0, 2).toLowerCase();
  config.params = { ...(config.params || {}), lang: lng, country: getDeliveryCountry() };
  return config;
});

// Watch API
export const watchApi = {
  getWatches: (params?: { brand?: string; minPrice?: number; maxPrice?: number }) =>
    apiClient.get('/api/watches', { params }),

  getWatchBySlug: (slug: string) =>
    apiClient.get(`/api/watches/${slug}`),
};

// Checkout API
export const checkoutApi = {
  reserveWatches: (watchIds: string[]) =>
    apiClient.post('/api/checkout/reserve', { watchIds }),

  createOrder: (orderData: {
    idempotencyKey: string;
    watchIds: string[];
    customerEmail: string;
    customerFirstName: string;
    customerLastName: string;
    customerPhone?: string;
    shippingZoneId: string;
    billingAddress: any;
    shippingAddress: any;
    paymentMethod?: string;
    notes?: string;
  }) => apiClient.post('/api/checkout', orderData),

  getShippingZones: () =>
    apiClient.get('/api/shipping-zones'),
};
